export const categories = [
  { id: "hot", name: "热门推荐", slug: "hot", icon: "ri-fire-line", description: "精选热门视频内容，每日更新推荐" },
  { id: "91video", name: "91视频", slug: "91video", icon: "ri-play-circle-line", description: "91视频品牌专区，海量高清视频资源" },
  { id: "97video", name: "97视频", slug: "97video", icon: "ri-film-line", description: "97视频品牌专区，精彩内容不间断" },
  { id: "51video", name: "51视频网站", slug: "51video", icon: "ri-tv-line", description: "51视频网站精选专区" },
  { id: "latest", name: "最新上线", slug: "latest", icon: "ri-rocket-line", description: "最新上线的视频内容，第一时间观看" },
  { id: "hd", name: "高清专区", slug: "hd", icon: "ri-4k-line", description: "高清画质视频专区，畅享极致视觉体验" },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});